<template>

  <ControlloFattureFornitoriEE />
 
</template>

<script>
import ControlloFattureFornitoriEE from '../components/pratiche/ControlloFattureFornitoriEE.vue'

export default {
  pageName: 'fatture',
  components: {
    ControlloFattureFornitoriEE

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
